import { render, staticRenderFns } from "./TeamInvitationModal.vue?vue&type=template&id=8b41eaec&scoped=true"
import script from "./TeamInvitationModal.vue?vue&type=script&lang=js"
export * from "./TeamInvitationModal.vue?vue&type=script&lang=js"
import style0 from "./TeamInvitationModal.vue?vue&type=style&index=0&id=8b41eaec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b41eaec",
  null
  
)

export default component.exports